export const centeredWithPadding = "p-4 sm:p-10 w-full max-w-7xl mx-auto";
export const centeredWithSidebarPadding =
  "p-4 sm:p-10 w-full max-w-7xl mx-auto";
